<template>
  <b-modal id="subdivisionsRemoveModal"
           class="subdivisionsRemoveModal"
           size="m"
  >
    <template #modal-title>
      <h5>
        <em class="fas fa-times-circle"></em> Удаление подразделений
      </h5>
    </template>

    <template #default>
      <b-alert show="" variant="danger">
        Вместе с подразделением будут удалены пользователи, Газпром-классы,
        а так же весь связанный контент (записи о классах, мероприятия класса).
      </b-alert>
      <div class="table" style="width: 100%; height: 40vh;">
        <ag-grid-vue
          class="remove-modal-grid ag-theme-material"
          :gridOptions="gridOptions"
          :rowData="chosenSubdivisions"
          :columnDefs="columnDefs"
          @onGridReady="onGridReady"
        >
        </ag-grid-vue>
      </div>
    </template>

    <template #modal-footer>
      <b-button cols="auto" @click="onSubmit"  variant="primary">
        <em class="fas fa-times-circle"></em> Удалить
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import { mapActions } from 'vuex'
import organizationApi from '@/api/organization'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'

export default {
  name: 'SubdivisionsRemoveModal',
  data() {
    return {
      gridOptions: {
        defaultColDef: {
          headerName: '',
          autoHeight: false,
          sortable: true,
          headerClass: 'subdivision-table-header',
          cellStyle: {
            'word-break': 'break-all'
          }
        },
        localeText: AG_GRID_LOCALE_RU,
        pagination: true,
        paginationPageSize: 20,
        rowHeight: 90,
        headerHeight: 40,
        enableCellTextSelection: true,
        suppressMenuHide: true
      },
      columnDefs: [
        {
          headerName: 'Название',
          field: 'title',
          width: 300
        },
        {
          headerName: 'Сайт',
          field: 'siteUrl'
        }
      ]
    }
  },
  props: {
    chosenSubdivisions: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi
      this.gridApi.sizeColumnsToFit()
      this.gridApi.setDomLayout('autoHeight')
    },
    onSubmit() {
      organizationApi.removeOrganizations(this.chosenSubdivisions)
        .then(() => {
          this.pushToasts({
            title: 'Уведомление',
            message: 'Подразделения успешно удалены.'
          })
          this.$bvModal.hide('subdivisionsRemoveModal')
          this.$emit('subdivisionsRemoved')
        })
        .catch(() => {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: 'Ошибка удаления подразделения. '
          })
        })
    },
    ...mapActions({
      pushToasts: 'toasts/pushToasts'
    })
  },
  components: {
    'ag-grid-vue': AgGridVue
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/vendor/bootstrap/variables";

.remove-modal-grid {
  width: 100%;
  height: 100%;
}

#subdivisionsRemoveModal .table {
  justify-content: left;
}

.subdivisions-table-header {
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: left;
  color: #000;
  font-weight: bold;
}

.ag-theme-alpine {
  width: 100% !important;
  height: 20% !important;
}

.modal-footer {
  border: 0;
}

.subdivisionsRemoveModal .ag-row .ag-cell {
  justify-content: left;
  text-align: left;
}
.subdivisionsRemoveModal .ag-header-cell-label {
  justify-content: left;
}
</style>
